import styled, { css } from 'styled-components';

export const StyledRow = styled.div<{
  isHead?: boolean;
  borderColor?: string;
  background?: string;
  hoverBackground?: string;
  displayMode?: 'flex' | 'table';
  alignItems?: string;
  height?: number;
}>`
  display: ${({ displayMode }) => displayMode === 'table' ? 'table-row' : 'flex'};
  align-items: ${({ alignItems }) => alignItems};
  background: ${({ background }) => background};

  &:hover {
    background: ${({ hoverBackground }) => hoverBackground};
  }

  ${({ height }) => height && css`
    height: ${height}px;
  `}

  ${({ isHead }) => !isHead && css<{
    borderColor?: string;
  }>`
    border-bottom: 1px ${({ theme, borderColor }) => borderColor || theme.colors.smoothGray} solid;
  `}
`;
